export default {
  actions: {
    cancel: "Cancel",
    withdraw: "Withdraw",
    delete: "Delete",
    askConfirm: "Do you want to confirm?",
    confirm: "Confirm",
    downloadData: "Download data",
    changePlan: "Change plan",
    send: "Send",
    enter: "Login",
    back: "Back",
    next: "Next",
    skip: "Skip this step",
    create: "Create",
    save: "Save",
    deleteAccount: "Delete account",
    search: "Search",
    yes: "Yes",
    no: "No",
    active: "Active",
    close: "Close",
    alreadyConnected: "Already connected",
    connectToStripe: "Connect to Stripe",
    goToLogin: "Go to Log In"
  },
  notifications: {
    changeSuccess: "Successfully saved changes",
    upgradeToPremium: "You must have a premium Subscription to use this feature"
  },
  error: {
    generic: "An error has occurred",
    accountAlreadyExists: "An account with this email already exists",
    companyAlreadyExists: "A company with this name already exists",
    duplicateCIF: "This CIF is already registered",
    validationError: "Please make sure your CIF/DNI are correct"
  },
  design: {
    button: "Design",
    layout: {
      title: "Layout",
      heading: "Heading",
      subtitle: "Subtitle"
    }
  },
  nav: {
    Web: "Web",
    Portfolio: "Portfolio",
    Tienda: "Shop",
    Eventos: "Events",
    Cuentas: "Accounts",
    Socios: "Partners",
    Empresa: "Company",
    Asesor: "Consultant",
    NFTs: "NFTs",
    Datos: "Data",
    Mejora: "Improve",
    Servicios: "Services",
    Blog: "Blog",
    Formación: "Training"
  },
  logout: "Logout"
};
